import React, { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../MainContext';


function Footer() {
  const { t } = useTranslation();

  const footerWrapRef = useRef(null);
  const footerRef = useRef(null);

  const isWide = useContext(mainContext).isWide;
  const setFooterWrapHeight = useContext(mainContext).setFooterWrapHeight;

  const footerHeight = useContext(mainContext).footerHeight;
  const setFooterHeight = useContext(mainContext).setFooterHeight;

  const isBottom = useContext(mainContext).isBottom;
  const setIsBottom = useContext(mainContext).setIsBottom;


  useEffect(() => {
    // 1番下へのスクロール判定
    const handleScroll = () => {
      const scrollTop = window.innerHeight + window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop >= documentHeight - 5) { //5px余分に
        setIsBottom(true);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // コンポーネントがアンマウントされるときにイベントリスナーを削除する
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [])


  // フッター全体の高さ
  useEffect(() => {
    if (footerWrapRef && footerWrapRef.current) {
      setFooterWrapHeight(footerWrapRef.current.offsetHeight);
    }
  }, [footerWrapRef, footerWrapRef.current])

  // フッターの高さ
  useEffect(() => {
    if (footerRef && footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight-2); //誤差修正
    }
  }, [footerRef, footerRef.current])


  return (
    <div>
      <div
        ref={footerWrapRef}
        className={`
          ${styles.scrollBtnWrap}
          ${styles.backOrange}
        `}
        style={{
          bottom: isBottom? footerHeight : 0,
          padding: isWide? '10px 0' : '10px 0 0 0'
        }}
      >
        <a href="https://line.me/R/ti/p/@055womqy" target="_blank">
          <img className={styles.scrollBtn} src={t('getBtn')} alt="無料で受け取る" />
        </a>
      </div>

      <footer ref={footerRef} className={styles.backOrange}>
        <p class="text-center mb-0 pt-1 pb-1">(c)Saito Nao</p>
      </footer>
    </div>
  );
}

export default Footer;